/// <reference path="DOMAttached.js" />

class PetOwnerSelector extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		this.sharedListUrl = options.sharedListUrl;
		this.filterMemberUrl = options.filterMemberUrl;
		this.dropDownList = document.getElementById(options.dropDownList);
		this.safeObserve(this.dropDownList, 'change', this.onChange.bind(this));
	}

	onChange() {
		var url = (this.dropDownList.options[this.dropDownList.selectedIndex].value === "null")
			? new UrlTemplate(this.sharedListUrl).url
			: new UrlTemplate(this.filterMemberUrl).r('PLH_nchild', this.dropDownList.options[this.dropDownList.selectedIndex].value).url;

		if (SharedListInstance.loadPageWithCustomUrl(0, url)) {
			event.preventDefault();
			event.stopPropagation();
		}
	}
}
